import React, { useEffect } from "react";
import supportImage1 from "../../assets/images/resources/how_get_support_1.png";
import supportImage2 from "../../assets/images/resources/how_get_support_2.png";

const HowToGetSupport = () => {
  useEffect(() => {
    document.title = "How to Get Support";

    const ensureLink = (id, rel, href, crossOrigin) => {
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = rel;
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    };

    ensureLink("rubik-preconnect-1", "preconnect", "https://fonts.googleapis.com");
    ensureLink("rubik-preconnect-2", "preconnect", "https://fonts.gstatic.com", "anonymous");
    ensureLink(
      "rubik-font-stylesheet",
      "stylesheet",
      "https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&display=swap"
    );
  }, []);

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div style={styles.headerDiv}>
          <span>
            <img
              style={styles.logo}
              alt="Blueprint Central Support"
              src="https://attachments-uk1-cloud-deskpro-com.s3.amazonaws.com/files/41732/8/7771SXYJNDABDHPZKRC0-Support-Portal-Logo.png"
            />
          </span>
          <span>Blueprint Central Support</span>
        </div>
      </header>

      <main style={styles.main}>
        <h1 style={{ ...styles.title, ...styles.center }}>How to Get Support</h1>

        <p style={styles.center}>
          <a style={styles.link} target="_blank" rel="noreferrer" href="https://support.blueprintcentral.com/">
            Click Here to Submit a New Customer Support Ticket
          </a>
        </p>

        <p style={styles.paragraph}>
          You have a dedicated support team ready to assist with any questions or issues you may have regarding the
          Buyers Club. Questions about the training? Trouble logging in? Technical issues? We are here to help!
        </p>

        <h2 style={styles.titleH2}>TO CREATE A NEW CUSTOMER SUPPORT TICKET:</h2>

        <ol style={styles.list}>
          <li>
            Go to <a style={styles.link} target="_blank" rel="noreferrer" href="https://support.blueprintcentral.com/">https://support.blueprintcentral.com/</a> and click on the
            Contact Us button
          </li>
          <li>Fill in your Name and Email address</li>
          <li>Click on 'Department' and choose 'Buyers Club' from the dropdown menu.</li>
        </ol>

        <img style={styles.image} src={supportImage1} alt="Formulario Contact Us" />

        <p style={styles.paragraph}>
          <strong>Contact Us</strong>
        </p>

        <p style={styles.paragraph}>
          Please complete this form and one of our agents will reply to you by email as soon as possible.
        </p>

        <ul style={styles.list}>
          <li>Name *</li>
          <li>Email *</li>
          <li>Department *</li>
          <li>Buyers Club</li>
          <li>Subject *</li>
          <li>Message *</li>
        </ul>

        <div style={styles.pagebreak} />

        <ol start={4} style={styles.list}>
          <li>
            Explain your issue, including any relevant links or screenshots (we will only open PNG, JPG, or PDF files).
            Include a link to a Loom video explaining the technical issue, if applicable.
          </li>
        </ol>

        <h2 style={styles.titleH2}>TO VIEW THE STATUS OF YOUR SUPPORT TICKETS:</h2>

        <h3 style={styles.titleH3}>STEP 1: Register for the Support Portal</h3>

        <p style={styles.paragraph}>
          <strong>Note:</strong> You MUST REGISTER on the Support Portal to be able to check the status of your tickets
          (your credentials to this Members Area will NOT work there).
        </p>

        <ol style={styles.list}>
          <li>
            Go to: <a style={styles.link} target="_blank" rel="noreferrer" href="https://support.blueprintcentral.com/register"> https://support.blueprintcentral.com/register</a>
          </li>
          <li>Click the "Log In button" in the top right corner</li>
          <li>Click on the "Register for an account" option</li>
          <li>Fill in all the required details on the form and then click the Register button:</li>
        </ol>

        <img style={styles.image} src={supportImage2} alt="Formulario Register" />

        <p style={styles.paragraph}>
          After you register, you can log in to the support portal using your new account details (username and
          password).
        </p>

        <p style={styles.paragraph}>
          If you previously registered on the Support Portal but forgot your password, go to the login page
          (<a style={styles.link} target="_blank" rel="noreferrer" href="https://support.blueprintcentral.com/login">https://support.blueprintcentral.com/login</a>) and use the "Need a password reminder?" link.
        </p>

        <p style={styles.paragraph}>
          You can always see the status of your ticket by logging in the support portal and then using the "My Tickets"
          link in the top right.
        </p>

        <div style={styles.pagebreak} />

        <h2 style={styles.titleH2}>BEST PRACTICES</h2>

        <ol style={styles.list}>
          <li>
            To get a faster response to your questions, please submit ONE ticket per issue. Submitting multiple
            questions in the same ticket will delay our response and make follow-up more difficult, as they will be
            routed to different support teams and handled accordingly.
          </li>
        </ol>

        <p style={styles.paragraph}>
          For example, if you have a problem logging in to the Members area and you have another question about the
          training, please create one ticket for each question.
        </p>

        <p style={styles.paragraph}>
          It's sometimes easier to explain an issue (especially a technical one) by sending a screenshot or a link to a
          short Loom video (<a style={styles.link} target="_blank" rel="noreferrer" href="https://www.loom.com">www.loom.com</a>).
        </p>

        <p style={styles.paragraph}>
          The support team will not open any attachments other than JPG, PNG, and PDF files for security reasons.
        </p>

        <ol start={2} style={styles.list}>
          <li>
            Please note that sending duplicate messages to obtain an immediate reply is not effective, as tickets are
            answered in the order they are received.
          </li>
        </ol>

        <p style={styles.paragraph}>
          Sending the same issue repeatedly complicates and delays the response. Also, it won't help you because tickets
          are answered in the order they are received. If you have new information to add to the same issue, simply open
          the original ticket and add a new message.
        </p>

        <p style={styles.paragraph}>
          You will NOT get support from the Buyers Club support team if you are not a registered member of the course.
          The only way we can confirm that is if you contact us from the registered email address.
        </p>

        <p style={styles.paragraph}>
          <strong>Thanks!</strong>
        </p>
      </main>
    </div>
  );
};

const styles = {
  page: {
    fontFamily:
      '"Rubik", sans-serif, "Lato", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    background: "#f4f5f7",
    margin: 0,
    padding: 0,
    color: "#4c4f50",
    lineHeight: 1.6,
    minHeight: "100vh",
  },
  header: {
    background: "#fff",
    borderBottom: "1px solid #dfe1e6",
    padding: "0 2rem",
    fontSize: 20,
    color: "#4c4f50",
    lineHeight: 2.8,
    margin: 0,
    position: "relative",
  },
  headerDiv: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  logo: {
    maxHeight: 49,
    borderStyle: "none",
    verticalAlign: "middle",
    boxSizing: "border-box",
  },
  main: {
    maxWidth: 900,
    margin: "30px auto",
    background: "#fff",
    padding: 30,
    borderRadius: 6,
    border: "1px solid #dfe1e6",
  },
  center: {
    textAlign: "center",
  },
  title: {
    color: "#172b4d",
  },
  titleH2: {
    color: "#3a8dde",
    fontWeight: 300,
    marginTop: 32,
    marginBottom: 12,
  },
  titleH3: {
    color: "#3a8dde",
    fontSize: "1.436625rem",
    fontWeight: 400,
    marginTop: 24,
    marginBottom: 12,
  },
  link: {
    color: "#0052cc",
    textDecoration: "none",
  },
  list: {
    marginLeft: 20,
    color: "#4c4f50",
  },
  image: {
    width: "100%",
    margin: "20px 0",
    border: "1px solid #ccc",
  },
  pagebreak: {
    margin: "40px 0",
    borderTop: "2px dashed #ccc",
  },
  paragraph: {
    marginBottom: 16,
    color: "#4c4f50",
  },
};

export default HowToGetSupport;
